<template>
  <div :class='["event", isFrame && "framed"]'>
    <div class="d-flex p-2 justify-content-center align-items-center" v-if="!event">
      <div class="focus">
        <div class="focus--mask">
          <div class="focus--mask-inner">QUICKLY</div>
        </div>
      </div>
    </div>
    <div v-if="event">
      <div v-if="!isMobileOnly">
        <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="logo">
        <img v-if="!dateTimeEventChecked && event.header" class="mx-auto d-block mb-3 test_iframe" :src="event.header"
             height="135px"
             alt="header">
      </div>
      <div v-else>
        <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="logo">
        <img v-if="!dateTimeEventChecked && event.mobileheader" class="mx-auto d-block test_iframe" :src="event.mobileheader"
             height="135px"
             alt="mobileheader">
      </div>
    </div>
    <div :class="isMobileOnly || isFrame ? 'd-table mx-auto' : 'container'" id="container">
      <div v-if="event">
        <div
            :class="{
            '': true, goingBack:
        isGoingBack}" :style="isMobileOnly ? '':''">
            <!-- Begin Calendar and hours range-->
            <div class="flex-container" v-if="!dateTimeEventChecked">
              <div class="w-100 back-calendar"
                   v-show="showCalendar" :style="isMobileOnly ? '':(isTablet || isFrame ?
                   'min-width: 462px; ' :
                   'min-width: 555px; ')">
                <h5 class="text-center mt-4 pl-5 pr-5">{{ event.description }}</h5>
                <h4 class="text-center">{{ $t('select_day_time') }}</h4>
                <DatePicker
                    :attributes='datePickerAttributes' :disabled-dates='excludeDates'
                    :locale="lang"
                    is-expanded is-inline v-model="startDateCalendar" @dayclick="onDayClick"/>
              </div>
              <div class="w-100" :style="isMobileOnly ? '':(isTablet || isFrame ?
                   'min-width: 480px; box-shadow: 1px 15px 10px -5px #ECECEC;' :
                   'min-width: 555px; box-shadow: 1px 15px 10px -5px #ECECEC;')"
                   v-show="!(isMobileOnly &&
              showCalendar)">
                <h6 :class="isMobileOnly ? 'text-center mt-3' : 'mt-4 ml-5'"> {{ $t('select_time') }} </h6>
                <div :class="isMobileOnly ? 'mb-2 mt-2 text-center' : 'mb-2 ml-5'">
                  <div class="detail-clock mb-3">
                    <div :class="isMobileOnly ? 'qck-hours-container-center mb-3' :
                  'qck-hours-container-left'"><Select2
                        :options="loadTimeZoneList" class="select2-custom" v-model="selectedTZ"/>
                    </div>
                    <div :class="isMobileOnly ? 'row col-12' : ''">
                      <div v-if="isMobileOnly" class="col-2"></div>
                      <div :class="!isMobileOnly ? 'mt-2' : 'col-4'"><i class="fas fa-clock mr-2"></i>{{
                          event.incrementTime }} Min</div>
                      <div :class="!isMobileOnly ? 'mt-2' : 'col-5'"><i class="fas fa-phone mr-2"></i>{{
                          $t('Phone')
                        }}</div>
                      <div v-if="isMobileOnly" class="col-1"></div>
                    </div>

                  </div>

                </div>
                <div :class="isMobileOnly ? 'qck-hours-container-center' : 'qck-hours-container-left'">
                  <template v-if="loadingTimeranges">
                    <div class="d-flex"><i class="fas fa-circle-notch fa-spin loader"></i></div>
                  </template>
                  <template v-else>
                    <div class="scrollbar">
                      <template v-if="timeranges.length > 0">
                        <div :key="timerange.itemId" class="hours" v-for="timerange in timeranges">
                          <a :class="buttonHourActif"
                             v-if="timerange.enabled && timerange.startDate != hour"
                             v-on:click="setHour(timerange.startDate)">{{ getHourMinute(timerange.startDate) }} </a>
                          <a :class="buttonHourActifChecked"
                             v-else-if="timerange.enabled && timerange.startDate == hour"
                             v-on:click="setHour(timerange.startDate)">{{ getHourMinute(timerange.startDate) }} </a>
                          <a :class="buttonHourInactif"
                             v-else>{{ getHourMinute(timerange.startDate) }} </a>
                        </div>
                      </template>
                      <template v-else>
                        <p class="text-center">{{ $t('no_timeranges_found') }}</p>
                      </template>
                    </div>
                  </template>
                </div>
                <div class="text-center mt-4">
                  <button class="qck-btn-retour float-left ml-1"
                          type="button"
                          v-if="!showCalendar"
                          v-on:click="showCalendar = true">{{ $t('Return') }}
                  </button>
                  <button :disabled="!date || !hour" :class="isMobileOnly ? 'qck-btn-center float-right mr-3' :
                  'qck-btn-center mt-3'"
                          type="button"
                          v-on:click="validateDateTime()">{{ $t('Next') }}
                  </button>
                </div>
              </div>
            </div>
            <!-- End Calendar and hours range-->

            <!-- Begin Contact Form -->
            <div class="col-md-12 col-sm-12 col-xs-12" key="sub2" v-else-if="!confirmationRdv &&
            !firstFormSubmitted" >
              <div :class="!isMobileOnly ? 'mr-5 ml-5' : ''">
                <h2 class="mb-5">{{ $t('contact_form_first_title') }}</h2>
                <div :class="!isMobileOnly ? 'row': ''">
                  <div class="col-12 col-sm-12 col-lg-5 mb-3">
                    <h4>{{ $t('contact_meeting_title') }}</h4>
                    <div :class="isMobileOnly ? 'text-meeting-mobile' : 'text-meeting'">{{ getDateString(dateTimeEventChecked.date) }}
                      - {{
                        dateTimeEventChecked.hour
                      }} à {{ getLocalEndingTime() }}
                    </div>
                    <div :class="isMobileOnly ? 'modify-mobile' : 'modify'" @click="dateTimeEventChecked = null">{{
                        $t('Modify') }}</div>
                  </div>
                <div v-if="!isMobileOnly" style="border-left: #C7C7C7 1px solid; height: 70px"></div>
                  <div class="col-12 col-sm-12 col-lg-5">
                    <div :class="isMobileOnly ? 'detail-list mb-2' : 'detail-list mb-2'">
                      <div :class="!isMobileOnly ? 'detail-clock mr-2 ml-3' : 'detail-clock'">
                        <i class="fas fa-clock mr-2"></i>{{ event.incrementTime }} Min <br v-if="!isMobileOnly">
                        <i :class="!isMobileOnly ? 'fas fa-phone mr-2 mt-2' : 'fas fa-phone ml-4 mr-2 mt-2 mb-3'"></i>{{
                          $t('Phone') }} <br>
                        <i class="fas fa-globe-europe mr-2 mt-2"></i>{{ getTimeZone(selectedTZ) }}
                      </div>
                    </div>
                  </div>
                </div>
                <form>
                  <h4 class="mt-4">{{ $t('contact_form_title') }}</h4>
                  <div class="form-row mb-1">
                    <div class="form-group col-md-6">
                      <label v-if="!isMobileOnly" for="prenom">{{ $t('Last Name') }}</label>
                      <input :disabled="disableFields" class="form-control" id="prenom" required
                             type="text" v-model="item.firstname" :placeholder="$t('Last Name')"/>
                    </div>
                    <div class="form-group col-md-6">
                      <label v-if="!isMobileOnly" for="nom">{{ $t('First Name') }}</label>
                      <input :disabled="disableFields" class="form-control" id="nom" required
                             type="text" v-model="item.lastname" :placeholder="$t('First Name')"/>
                    </div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="form-group col-md-6">
                      <label v-if="!isMobileOnly" for="email">{{ $t('Email address') }}</label>
                      <input :disabled="disableFields" class="form-control" id="email" required
                             type="text" v-model="item.email" :placeholder="$t('Email address')"/>
                    </div>
                    <div class="form-group col-md-6">
                      <label v-if="!isMobileOnly" for="phone">{{ $t('Phone number') }}</label>
                      <vue-phone-number-input :default-country-code=indicative :disabled="disableFields"
                                              :preferred-countries=prefered_indicatives
                                              :translations="{countrySelectorLabel:
                                                                            $t('Country Code') ,countrySelectorError:
                                                                            $t('Choose a country'),phoneNumberLabel: $t('Phone'),example: $t('Example') + ' :'}"
                                              id="phone"
                                              required
                                              @update="internationalPhoneNumber = $event.formatInternational"
                                              v-model="item.phone"/>
                    </div>
                  </div>
                  <div class="form-row">
                                <textarea v-if="!note" :disabled="disableFields" class="form-control" id="comment1"
                                          rows="3"
                                          :placeholder="$t('contact_form_comment')"
                                          v-model="item.comment"></textarea>
                    <textarea v-else :disabled="disableFields" class="form-control" id="comment2" rows="3"
                              :placeholder="note"
                              v-model="item.comment"></textarea>
                  </div>
                  <div class="card container border-0 pt-3">
                    <div>
                      <input class="form-check-input" id="contactAuth" type="checkbox"
                             v-model="item.contactAuth">
                      <label class="form-check-label " for="contactAuth"
                             style="font-size: 11px">* {{ $t('agreement') }}</label>
                    </div>
                    <div>
                      <input class="form-check-input" id="notifyIfFreeTimeSlot" type="checkbox"
                             v-model="item.notifyIfFreeTimeSlot">
                      <label class="form-check-label " for="notifyIfFreeTimeSlot"
                             style="font-size: 11px">{{ $t('notifyIfFreeTimeSlot') }}</label>
                    </div>
                  </div>
                  <div class="pt-3 pb-4">
                    <button class="qck-btn-retour" type="button"
                            v-on:click="dateTimeEventChecked = null">{{ $t('Return') }}
                    </button>
                    <button :disabled="disableFields || !firstFormCompleted" class="qck-btn float-right" type="button"
                            v-on:click="createClientEvent()">{{ $t('Confirm') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <!-- End Contact Form-->

            <!-- Begin Confirmation Message-->
            <div class="slideBlock" key="sub3" v-else>
              <div class="center">
                <h2 class="text-center">{{ $t('appointment_confirmed') }} <br> {{ $t('confirm_sent_email') }}</h2>
              </div>
              <div class="text-center">
                <button class="qck-btn-dateTimeSlot" type="button"
                        v-if="dateTimeEventChecked && !isMobileOnly">{{
                    getDateString(dateTimeEventChecked.date)
                  }} - {{
                    dateTimeEventChecked.hour
                  }} à {{ getLocalEndingTime() }}
                </button>

                <button class="qck-btn-dateTimeSlot-mobile" type="button"
                        v-if="dateTimeEventChecked && isMobileOnly">{{
                    getDateString(dateTimeEventChecked.date)
                  }} <br> {{
                    dateTimeEventChecked.hour
                  }} à {{ getLocalEndingTime() }}
                </button>
              </div>
              <div :class="isMobileOnly ? 'center mt-3' : 'center mt-4 w-50'" :style="!isMobileOnly ? 'padding-left: 100px' :
               ''">
                <div :class="isMobileOnly ? 'detail-list mb-2' : 'detail-list mb-2'">
                  <div class="detail-clock mr-2 ml-4 mb-4">
                    <i class="fas fa-clock mr-2 mb-2"></i>{{ event.incrementTime }} Min <br>
                    <i class="fas fa-phone mr-2 mb-2"></i>{{ $t('Phone') }} <br>
                    <i class="fas fa-globe-europe mr-2 mb-2"></i>{{ getTimeZone(selectedTZ) }}
                  </div>
                </div>
              </div>
              <hr :class="isMobileOnly ? 'w-100' : 'w-75'">
              <div class="text-center">
                <div class="col-12 col-sm-12 col-md-12 col-xs-12"><h3>{{
                    $t('add_to_agenda')
                  }} </h3></div>
                <div :class="isMobileOnly ? 'd-flex justify-content-around' :
                'd-flex justify-content-around'">
                  <add-to-calendar :title="event.name"
                                   :location="$t('appointement_phone')"
                                   :start="new Date(timezoneDateTimeDiff(item.startDate))"
                                   :end="new Date(new Date(timezoneDateTimeDiff(item.startDate)).getTime() +
                                   item.incrementTime*60000)"
                                   :details="event.description"
                                   inline-template class="pb-5">
                    <div>

                      <google-calendar id="google-calendar" class="iconAddToCalendarGoogle">
                        <div>{{$t('Google agenda')}}</div>
                      </google-calendar>

                      <microsoft-calendar id="microsoft-calendar" class="iconAddToCalendarOutlook">
                        <div>{{$t('Outlook agenda')}}</div>
                      </microsoft-calendar>
                    </div>
                  </add-to-calendar>
                </div>

              </div>
              <hr :class="isMobileOnly ? 'w-100' : 'w-75'">
              <div class="text-center mb-4" style="font-family: 'Open Sans'; font-size: 14px; color: #838383">
                {{ $t('Pour annuler ou déplacer votre rendez-vous') }} <router-link :to="{ path: pathCanceled }"> {{ $t('click here') }}</router-link><br>
                {{ $t('Attention: pour modifier votre rendez-vous il vous faudra d’abord l’annuler') }}

              </div>
            </div>
            <!-- End Confirmation Message-->


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone'
import Select2 from 'v-select2-component';
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import {api, imagePath, cognitoCredentials, cognitoApp} from '../../config';
import {isMobileOnly, isTablet} from "mobile-device-detect";
import AddToCalendar from 'vue-add-to-calendar'

export default {
  metaInfo() {
    return {
      title: this.lang === "en" ? "A member of the team will call you back for free consultation" : "Notre équipe vous rappelle gratuitement",
    }
  },
  components: {
    DatePicker,
    Select2,
    AddToCalendar
  },
  name: 'Event',
  props: {
    isFrame: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      images: {
        appleCalendar: require('@/assets/img/apple-agenda.svg'),
        googleCalendar: require('@/assets/img/google-agenda.svg'),
        outlookCalendar: require('@/assets/img/outlook-agenda.svg')
      },
      selectedTZ: null,
      imagePath: imagePath,
      cognitoCredentials: cognitoCredentials,
      cognitoApp: cognitoApp,
      accessToken: "",
      eventSlug: "",
      event: null,
      eventDates: [],
      timeranges: [],
      startDateCalendar: moment().add(1, "day").toDate(),
      lang: "",
      hour: null,
      note: null,
      disableFields: false,
      problem: false,
      loadingTimeranges: false,
      buttonHourActif: 'hours-open left',
      buttonHourActifChecked: 'hours-checked left',
      buttonHourInactif: 'hours-disabled left disable',
      dateTimeEventChecked: null,
      firstFormSubmitted: false,
      item: {
        startDate: null,
        incrementTime: null,
        firstname: null,
        lastname: null,
        email: null,
        comment: null,
        phone: null,
        eventId: null,
        image: null,
        headerImage: null
      },
      image: null,
      confirmationRdv: false,
      indicative: "FR",
      prefered_indicatives: ["FR", "GB", "US"],
      internationalPhoneNumber: null,
      isGoingBack: false,
      showCalendar: true,
      lastDaySelected: '',
      defaultColor: '#00DB77',
      eventDatesWithoutFirstDate: [],
      pathCanceled: ""
    }
  },
  computed: {
    date: {
      set (nextDay) {
        if(nextDay !== null && this.getDate(this.lastDaySelected) !== this.getDate(nextDay)) {
          this.eventDates = this.eventDates.filter(e => e !== this.getDate(nextDay))
          this.lastDaySelected = nextDay;
          if (isMobileOnly) this.showCalendar = false;
          this.emitEvent({type: 'date_chosen'});
          this.loadingTimeranges = true;
          this.timeranges = [];
          let day = this.getDate(nextDay);
          this.getTimerangeFromDateEvent(this.event.itemId, day);
        }
      },
      get () {
        return this.lastDaySelected ? this.lastDaySelected : this.startDateCalendar;
      }
    },
    isMobileOnly() {
      return isMobileOnly
    },
    isTablet() {
      return isTablet
    },
    firstFormCompleted() {
      return !!(this.item.firstname && this.item.lastname && this.item.email && this.item.phone && this.item.contactAuth);
    },
    secondFormCompleted() {
      return !!(this.firstFormCompleted);
    },
    datePickerAttributes() {
      return [
        {
          key: 'nextDate',
          highlight: {
            class: 'highlight-enable-day',
            contentClass: 'content-day-enabled',
          },
          dates: [this.getDate(this.date)],
          order: 1
        },
        {
          key: 'otherdays',
          highlight: 'white',
          dates: this.eventDates
        },
      ];
    },
    excludeDates() {
      let startDate = new Date(this.event.startDate);
      let today = new Date();

      if (startDate > today) {
        startDate.setDate(startDate.getDate() - 1);
      } else {
        startDate = today;
      }

      let endDate = new Date(this.event.endDate);
      endDate.setDate(endDate.getDate() + 1);

      let excludeDatesArray = [
        // Use date ranges
        {
          start: new Date(1900, 0, 1),
          end: startDate,
        },
        {
          start: endDate,
          end: new Date(3000, 11, 31),
        },
        // Or single dates
        //new Date(2019, 11, 28),
        //new Date(2019, 11, 29),
      ];

      return excludeDatesArray;
    },
    loadTimeZoneList() {
      let timeZones = moment.tz.names();
      let listTimeZones = [];
      timeZones.forEach((timeZone, index) => {
        listTimeZones[index] = {
          "text": `${timeZone} (GMT${moment.tz(timeZone).format('Z')})`,
          "id": timeZone
        };
      });
      return listTimeZones;
    },
    step() {
      let res = 0;
      for (let key of ['dateTimeEventChecked', 'firstFormSubmitted', 'confirmationRdv']) {
        if (this[key])
          res++;
        else
          break;
      }
      return res;
    }
  },
  created() {
    let $this = this;
    this.getCognitoAccessToken();
    this.selectedTZ = moment.tz.guess();
    $this.eventSlug = $this.$route.params.slug;

    if ($this.isFrame) {
      document.body.classList.add('removebg');
    }

    axios.get(api.url + 'event/slug/' + $this.eventSlug)
        .then(response => {
          if (response.data && $this.eventSlug.indexOf("canceled") < 0) {
            let eventData = response.data;
            axios.get(api.url + 'event/dates/' + eventData.itemId)
                .then(response => {
                  if (response.data) {
                    $this.event = eventData;
                    $this.logo = $this.event.logo;
                    $this.eventDates = response.data;
                    $this.note = $this.event.note;
                    $this.$i18n.locale = ($this.event.language) ? $this.event.language : 'fr';
                    $this.lang = ($this.event.language) ? $this.event.language : 'fr';
                    $this.event.color ? this.change_vars($this.event.color) : this.change_vars(this.defaultColor);

                    if ($this.event.language === 'fr') {
                      this.indicative = "FR"
                      this.prefered_indicatives = ['FR', 'GB', 'US']
                    } else if ($this.event.language === 'en') {
                      this.indicative = "GB"
                      this.prefered_indicatives = ['GB', 'US', 'FR']
                    }

                    if($this.eventDates.length > 0) {
                      this.startDateCalendar = $this.eventDates.reduce(function (accumulator, currentValue) {
                        return Date.parse(accumulator) > Date.parse(currentValue) ? currentValue : accumulator;
                      });
                      this.getTimerangeFromDateEvent(eventData.itemId, this.startDateCalendar);
                    }
                  }
                })
                .catch(error => {
                  return error;
                });

          } else if (response.data && $this.eventSlug.indexOf("cancelation") > 0) {
            this.$router.push({
              name: 'Canceled'
            });
          } else {
            this.$router.push({
              name: 'NotFound'
            });
          }
        })
        .catch(error => {
          console.log(error);
          return error;
        });
  },

  watch: {
    secondFormCompleted(nextVal, prevVal) {
      if (nextVal && !prevVal)
        this.emitEvent({type: "form_completed"});
    },
    step(nextVal, prevVal) {
      this.isGoingBack = nextVal < prevVal;
    }
  },
  methods: {
    getDateString(value) {
      const parsedDate = moment(value);
      return parsedDate.locale(this.lang).format('LL');
    },

    getWeekDay(value) {
      let day = moment(value).locale(this.lang).format('dddd')
      return day
    },

    getHourMinute(value) {
      let time;
      if (this.lang === 'fr') {
        time = moment(this.timezoneDateTimeDiff(value)).format('H:mm');
      } else if (this.lang === 'en') {
        time = moment(this.timezoneDateTimeDiff(value)).format('h:mm a');
      }
      return time;
    },

    getDate(value) {
      return moment(value).format('Y-MM-DD')
    },
    setHour(value) {
      this.hour = value;
      this.emitEvent({
        type: 'hour_chosen',
      });
    },
    checkFirstFormInput() {
      this.firstFormSubmitted = true;
    },

    validateDateTime() {
      if (this.date && this.hour) {
        this.dateTimeEventChecked = {
          date: this.getDate(this.date),
          hour: this.getHourMinute(this.hour)
        }
        this.item.startDate = this.hour;
        this.item.incrementTime = this.event.incrementTime;
        this.item.eventId = this.event.itemId;
        window.scrollTo(0, 0);
        this.emitEvent({
          type: 'date_and_hour_chosen',
        });
      }
    },

    getLocalEndingTime() {
      let val = moment.utc(this.hour).clone().add(this.event.incrementTime, 'minutes');
      if (this.lang === 'fr')
        return val.tz(this.selectedTZ).format('H:mm');
      return val.tz(this.selectedTZ).format('h:mm a');
    },
    createClientEvent() {
      if (this.secondFormCompleted) {
        this.disableFields = true;
        this.problem = false;
        this.item.timezone = this.selectedTZ;
        this.item.image = this.logo;
        this.item.headerImage = this.event.header;
        this.item.lang = this.lang;
        this.item.phone = this.internationalPhoneNumber ? this.internationalPhoneNumber : this.item.phone;
        this.emitEvent({type: 'create_event'});
        axios.post(api.url + 'client', this.item,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': this.accessToken
              }
            })
            .then(response => {
              this.confirmationRdv = true;
              this.disableFields = false;
              this.emitEvent({type: 'event_created'});
              let clientId = response.data.itemId;
              this.pathCanceled ="/canceled/" + clientId + "/" + this.item.eventId + "/" + this.eventSlug + "/" + this.lang + "";
              return response.data;
            })
            .catch(error => {
              console.log(error);
              this.problem = true;
              this.disableFields = false;
              return error;
            });
      }
    },
    timezoneDateTimeDiff(time) {
      let utcDate = moment.utc().format();
      let localDate = moment().tz(this.selectedTZ).format();

      if (utcDate !== localDate) {
        return moment.utc(time).tz(this.selectedTZ).format("YYYY-MM-DD HH:mm");
      }

      return time;
    },

    getTimeZone(timez) {
      return timez + "(GMT" + moment.tz(timez).format('Z') + ")";
    },
    getCognitoAccessToken() {
      axios.post(this.cognitoApp, '',
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'AuthFlow': 'REFRESH_TOKEN_AUTH'
            },
            auth: this.cognitoCredentials
          })
          .then(response => {
            this.accessToken = response.data.access_token;
          })
          .catch(error => {
            console.log(error);
            return error;
          })
    },
    emitEvent({type, ...otherData}) {
      try {
        if (!this.isFrame || !window.parent)
          return;
        const data = {
          eventId: this.eventSlug,
          event: 'quickly_' + type,
          ...otherData,
        };
        if (this.hour)
          data.hour = this.hour;
        if (this.date)
          data.date = this.date.toISOString().split('T')[0];
        window.parent.postMessage({
          type: 'quicklyEvent',
          data,
        }, '*');
      } catch (e) { // Make sure we don't crash the app
        console.warn(e);
      }
    },
    getTimerangeFromDateEvent(eventId, day) {
      axios.get(api.url + 'timeranges?eventId=' + eventId + '&date=' + this.getDate(day))
          .then(response => {
            this.timeranges = response.data;
            this.hour = this.timeranges.length > 0 ? this.timeranges[0].startDate : '';
            this.loadingTimeranges = false;
            window.scrollTo(0, document.body.scrollHeight);
            this.emitEvent({type: 'fetched_hours', count: response.data?.length});
          })
          .catch(error => {
            console.log(error);
            this.loadingTimeranges = false;
            return error;
          })
    },
    change_vars(color) {
      let body = document.getElementsByTagName("body")[0];
      body.style.setProperty('--calendar-color', color);
      body.style.setProperty('--calendar-color-lighten', this.LightenColor(color, 95));
    },
    LightenColor(color, percent) {
      let num = parseInt(color.replace("#", ""), 16),
          amt = Math.round(2.55 * percent),
          R = (num >> 16) + amt,
          B = (num >> 8 & 0x00FF) + amt,
          G = (num & 0x0000FF) + amt;
      return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
    },
    onDayClick(day){
      this.date = day.id;
    },
    ifWeekendNextDayIs(date) {
      if(date.getDay() === 6)
      {
        return new Date(date.setDate(date.getDate() + 2));
      } else if(date.getDay() === 0) {
        return new Date(date.setDate(date.getDate() + 1));
      } else {
        return date;
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

@-webkit-keyframes mask-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(189px);
    transform: translateX(189px);
  }
}

@keyframes mask-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(189px);
    transform: translateX(189px);
  }
}

@-webkit-keyframes mask-inner-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-189px);
    transform: translateX(-189px);
  }
}

@keyframes mask-inner-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-199px);
    transform: translateX(-189px);
  }
}

.focus {
  color: black;
  font-size: 3rem;
  text-transform: uppercase;
  letter-spacing: .2rem;
  line-height: 1;
  position: relative;
  width: 239px;
}

.focus:before {
  content: 'QUICKLY';
  -webkit-filter: blur(3px);
  filter: blur(3px);
}

.focus:after {
  content: '';
  position: absolute;
  width: 50px;
  height: calc(100% + 8px);
  top: -4px;
  left: 0;
  border-top: 1px solid;
  border-bottom: 1px solid;
  -webkit-animation: mask-move 1s linear infinite alternate;
  animation: mask-move 1s linear infinite alternate;
}

.addOverFlow {
  overflow: hidden;
}

.focus--mask {
  overflow: hidden;
  position: absolute;
  width: 50px;
  height: 100%;
  top: 0;
  left: 0;
  background: #fff;
  -webkit-animation: mask-move 1s linear infinite alternate;
  animation: mask-move 1s linear infinite alternate;
}

.focus--mask-inner {
  -webkit-animation: mask-inner-move 1s linear infinite alternate;
  animation: mask-inner-move 1s linear infinite alternate;
}
</style>

<style>
.select2-custom span.select2 .selection .select2-selection {
  border-radius: 0 !important;
  border: 0px;
  font-size: 12px;
  text-align: center;
}

.select2-container {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  margin: 0;
  position: relative;
  vertical-align: middle;
  width: 75% !important;
}

.scrollbar {
  height: 200px;
  width: 100%;
  margin-block: 0;
  overflow-y: scroll;
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
}

.eventImg {
  max-width: 300px;
  width: 90%; /* Make sure we are not too large for the container */
}

@keyframes slide {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}

@keyframes slide-back {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
}

@keyframes slide-back-other {
  0% {
    transform: translate(-200%, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}

@keyframes slide-opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slide-margin {
  0% {
    margin-right: 0;
  }
  100% {
    margin-right: 20px;
  }
}

.modernSlide-enter-active {
  animation: slide ease-out .2s, slide-opacity linear .2s, slide-margin linear .2s;
}

.modernSlide-leave-active {
  animation: slide ease-in .2s, slide-opacity reverse linear .2s, slide-margin reverse linear .2s;
}

.slideContainer {
  flex-direction: row;
  align-items: center;
  display: flex;
  background-color: white;
}

.slideBlock {
  min-width: 100%;
  flex: 0;
  margin-right: 20px;
}

.goingBack.slideContainer .modernSlide-enter-active {
  animation: slide-back-other ease-out .2s, slide-opacity linear .2s, slide-margin linear .2s;
}

.goingBack.slideContainer .modernSlide-leave-active {
  animation: slide-back ease-in .2s, slide-opacity reverse linear .2s, slide-margin reverse linear .2s;
}

@media (max-width: 780px) {
  .slideContainer {
    align-items: flex-start !important;
  }
}

.row {
  flex-wrap: nowrap;
}

@media (max-width: 780px) {
  .test_iframe {
    display: none !important;
  }
}

@media (min-width: 780px) {
  .test_iframe {
    display: block;
  }
}



@media (min-width: 718px) {
  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }
}

@media (max-width: 718px) {
  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }
}


</style>
